import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { useParams } from '@solidjs/router';
import { createMagicDoorContext } from '~/contexts/utils';
import { PropertiesBillsRepository } from '~/repositories/propertiesBillsRepository';
import type { AddPropertyChargeDto, AdjustPropertyChargeDto } from '~/swagger/portal/Api';
const repo = new PropertiesBillsRepository();

export const [PropertiesBillsProvider, usePropertiesBills] = createMagicDoorContext('propertiesBill', () => {
  const { propertyId } = useParams();

  const [filtered, setFilter, actions] = createTriggerResource((filter: any) => repo.getPropertyBills(propertyId, filter));

  const createPropertyBill = createMutation(async (data: AddPropertyChargeDto) => {
    return await repo.createPropertyBill(propertyId, data);
  });

  const updatePropertyBill = createMutation(async (billId: string, data: AdjustPropertyChargeDto) => {
    await repo.updatePropertyBill(propertyId, billId, data);
    actions.refetch();
  });

  const getPropertyBill = createMutation(async (billId: string) => {
    return await repo.getPropertyBill(propertyId, billId);
  });

  const deletePropertyBill = createMutation(async (billId: string) => {
    await repo.deletePropertyBill(propertyId, billId);
    actions.refetch();
  });

  return {
    filtered,
    setFilter,
    createPropertyBill,
    updatePropertyBill,
    deletePropertyBill,
    getPropertyBill,
    actions,
  };
});
